import { createRouter, createWebHashHistory } from 'vue-router';

const routes = [
  {
    name: 'notFound',
    path: '/:path(.*)+',
    redirect: {
      name: 'login',
    },
  },
  {
    name: 'login',
    path: '/login',
    component: () => import('./view/login.vue'),
    meta: {
      title: '尧都区殡葬服务中心',
    },
  },
  {
    name: 'user',
    path: '/user',
    component: () => import('./view/user'),
    meta: {
      title: '联系方式',
    },
  },
  {
    name: 'cart',
    path: '/cart',
    component: () => import('./view/cart'),
    meta: {
      title: '收费公示',
    },
  },
  {
    name: 'fee2',
    path: '/fee2',
    component: () => import('./view/fee2.vue'),
    meta: {
      title: '公墓收费',
    },
  },
  {
    name: 'goods',
    path: '/goods',
    component: () => import('./view/goods'),
    meta: {
      title: '优惠政策',
    },
  },
  {
    name: 'process',
    path: '/process',
    component: () => import('./view/process.vue'),
    meta: {
      title: '治丧流程',
    },
  },
  {
    name: 'ghsave',
    path: '/ghsave',
    component: () => import('./view/ghsave.vue'),
    meta: {
      title: '骨灰寄存',
    },
  },{
    name: 'fire',
    path: '/fire',
    component: () => import('./view/fire.vue'),
    meta: {
      title: '火化证明',
    },
  },
];

const router = createRouter({
  routes,
  history: createWebHashHistory(),
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export { router };
